import React from 'react'

import HARDCODE from '../../../business-const/HardCode/HardCode'

import LABEL from '../../../business-const/Label/Label'

import {
    ValidatorFormPadrao,
} from '../../../business-components/Form/Form'

import {
    ButtonAlterarParametros,
    ButtonAlterarHipotesesFinanceiras,
} from '../../../business-components/Button/Button'

import {
    IconButtonSelecionarCenariosTipoMorteInvalidez,
    IconButtonEstudoParametros,
} from '../../../business-components/IconButton/IconButton'

import {
    CustomizedDialogsPopup,
} from '../../../business-components/Dialog/CustomizeDialogs'

import {
    EstudoFormCenarios,
} from '../estudo-parametros/EstudoFormCenarios'

import SimulacaoFinanceiraFormParametros from './SimulacaoFinanceiraFormParametros'

import SimulacaoFinanceiraFormHipotesesFinanceiras from './SimulacaoFinanceiraFormHipotesesFinanceiras'

import SimulacaoFinanceiraFormConfiguracao from './SimulacaoFinanceiraFormConfiguracao'

import ComparacaoCenariosEstudosChart from '../estudo-chart/ComparacaoCenariosEstudosChart'

import EstudoFormComparacaoCenariosEstudos from '../estudo-form/EstudoFormComparacaoCenariosEstudos'



export const CustomizedDialogsPopupParametros = ( {variaveisGlobais, values, handleChange, handleSubmit, setFieldValue,
    handleSubmitAutomatico, estudo, vars} ) => {

    return (
        <CustomizedDialogsPopup
            maxWidth='md'
            popupTitle={LABEL.buttonAlterarParametros}
            PopupButton={ButtonAlterarParametros}
            popupComponent={
                <ValidatorFormPadrao
                    onSubmit={handleSubmit}
                    onError={
                        () => null
                    }
                >
                    <SimulacaoFinanceiraFormParametros
                        variaveisGlobais={variaveisGlobais}
                        values={values}
                        handleChange={handleChange}
                        handleSubmit={handleSubmit}
                        setFieldValue={setFieldValue}
                        handleSubmitAutomatico={handleSubmitAutomatico}
                        estudo={estudo}
                        vars={vars}
                        popup={true}
                    />
                </ValidatorFormPadrao>
            }
        />
    )
}

export const CustomizedDialogsPopupHipotesesFinanceiras = ({ variaveisGlobais, values, handleChange, handleSubmit, setFieldValue,
    handleSubmitAutomatico, estudo, vars, linhaFormList }) => {

    return (
        <CustomizedDialogsPopup
            maxWidth='md'
            popupTitle={LABEL.buttonAlterarHipotesesFinanceiras}
            PopupButton={ButtonAlterarHipotesesFinanceiras}
            popupComponent={
                <ValidatorFormPadrao
                    onSubmit={handleSubmit}
                    onError={
                        () => null
                    }
                >
                    <SimulacaoFinanceiraFormHipotesesFinanceiras
                        variaveisGlobais={variaveisGlobais}
                        values={values}
                        handleChange={handleChange}
                        //handleSubmit={handleSubmit}
                        setFieldValue={setFieldValue}
                        handleSubmitAutomatico={handleSubmitAutomatico}
                        estudo={estudo}
                        vars={vars}
                        linhaFormList={linhaFormList}
                        popup={true}
                    />
                </ValidatorFormPadrao>
            }
        />
    )
}

export const CustomizedDialogsPopupConfiguracaoSimulacaoFinanceira = ( { values, handleChange, handleSubmit, setFieldValue } ) => {

    return (
        <CustomizedDialogsPopup
            maxWidth='lg'
            popupTitle={LABEL.configuracaoSimulacaoFinanceira}
            tooltipTitle={LABEL.configuracaoSimulacaoFinanceira}
            PopupButton={IconButtonEstudoParametros}
            bgDefault={true}
            popupComponent={
                <>
                    <EstudoFormCenarios
                        values={values}
                        handleChange={handleChange}
                        handleSubmit={handleSubmit}
                        setFieldValue={setFieldValue}
                        toogle={false}
                    />

                    <SimulacaoFinanceiraFormConfiguracao
                        values={values}
                        handleChange={handleChange}
                        handleSubmit={handleSubmit}
                    />
                </>
            }
        />
    )
}

export const CustomizedDialogsPopupSelecionarCenarios = ({ variaveisGlobais, values, handleChange, handleSubmit, setFieldValue,
    handleSubmitAutomatico, estudo, linhaTipoLicenca, jsonConfiguracao, jsonPagina, jsonUsuario, jsonUsuarioAdmin }) => {

    return (
        values.cenarios.length > 1
            ?
                <CustomizedDialogsPopup
                    maxWidth="xl"
                    popupTitle={LABEL.selecionarCenarios}
                    tooltipTitle={LABEL.selecionarCenarios}
                    PopupButton={IconButtonSelecionarCenariosTipoMorteInvalidez}
                    bgDefault={true}
                    popupComponent={
                        <>
                            <EstudoFormCenarios
                                values={values}
                                handleChange={handleChange}
                                handleSubmit={handleSubmit}
                                setFieldValue={setFieldValue}
                                toogle={false}
                            />

                            <ComparacaoCenariosEstudosChart
                                variaveisGlobais={variaveisGlobais}
                                values={values}
                                handleSubmitAutomatico={handleSubmitAutomatico}
                                estudo={estudo}
                                report={false}
                                linhaTipoLicenca={linhaTipoLicenca}
                                jsonConfiguracao={jsonConfiguracao}
                                jsonPagina={jsonPagina}
                                jsonUsuario={jsonUsuario}
                                jsonUsuarioAdmin={jsonUsuarioAdmin}
                                comparacaoCenariosEstudosTipo={HARDCODE.comparacaoCenariosEstudosTipoCenario}
                                simulacaoFinanceira={true}
                                popup={false}
                                selecaoCenarios={true}
                            />

                            <EstudoFormComparacaoCenariosEstudos
                                variaveisGlobais={variaveisGlobais}
                                values={values}
                                handleSubmitAutomatico={handleSubmitAutomatico}
                                estudo={estudo}
                                linhaTipoLicenca={linhaTipoLicenca}
                                jsonConfiguracao={jsonConfiguracao}
                                jsonPagina={jsonPagina}
                                jsonUsuario={jsonUsuario}
                                jsonUsuarioAdmin={jsonUsuarioAdmin}
                                comparacaoCenariosEstudosTipo={HARDCODE.comparacaoCenariosEstudosTipoEstudo}
                                simulacaoFinanceira={false}
                            />
                        </>
                    }
                />
            :
                ''
        )
}